import { postV1SupportToken, type SupportTokenPostBody } from '../../api/generated/pap';

/**
 * Support Token generation for the Topcon ID feature. Stays a plain async
 * function rather than a `useMutation` hook: `TopconId.tsx` awaits it inside
 * its own loading state, and no cached query depends on the result.
 */
export async function generateSupportToken(options: SupportTokenPostBody): Promise<string> {
  const { data } = await postV1SupportToken({ body: options, throwOnError: true });
  return data.token;
}
